module.exports = __webpack_public_path__ + "img/icon-hamburger.6af0ad46.svg";